<ng-container *ngIf="!(heatingPanelService.isEcoMode$ | async)">
  <ng-container *ngIf="eco$ | async | ready as feature">
    <app-program-panel
      *ngIf="feature?.properties?.active?.value"
      data-at-eco-panel
      [program]="feature.feature | modeName"
      [active]="feature?.properties?.active?.value"
    >
      <vi-icon icon name="heating-mode-{{ feature.feature | modeName }}" [size]="20"></vi-icon>
      <ng-container message>{{ '+SCHEDULES.PROGRAM_PANEL.ECO_MODE' | translate }}</ng-container>
    </app-program-panel>
  </ng-container>
</ng-container>
